<div class="container mt-3">
  <ng-container *ngIf="gamesGroup$ | async as gamesGroup">
    <ng-container *ngIf="gamesGroup.length > 0; else noGame">
      <fgbcl-games-group-list [gamesGroup]="gamesGroup" [groupType]="groupType"></fgbcl-games-group-list>
    </ng-container>
    <ng-template #noGame>
      <div class="d-flex align-items-center justify-content-center no-game-card">
        {{ 'fgbcl.game.no.trivia.game.available.text' | translate }}
      </div>
    </ng-template>
  </ng-container>
</div>
